import { Action, Reducer } from 'redux';
import { AppThunkAction } from ".";
import { UserState } from "./User";
//import { SessionModel } from "../models/SessionModel";
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
 
export interface Widget {
    widgetTitle: string;
    sortId: number;
    widgetGroupName: string;
    widgetCount: number;
    arCustomerNum: string;
    serviceMaster: string;
    widgetInternalName: string;
    pictureName: string;
}

const initialWidgetState: Widget = {
    widgetTitle: "",
    sortId:0,
    widgetGroupName:"",
    widgetCount:0,
    arCustomerNum:"",
    serviceMaster:"",
    widgetInternalName:"",
    pictureName:""    
}

export interface WidgetList {
    items: Widget[];
    loaded: boolean;
}

export const initialWidgetListState: WidgetList = { items: [], loaded: false };

export interface LoadWidgets { type: 'WIDGET_LOAD', newState: WidgetList }

export type KnownAction = LoadWidgets | ResetStore;

export const actionCreators = {
    loadWidgets: (pCompanyCode: string, pARNum: string, pSMNum: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState();             

        const args = "pCompanyCode=" + pCompanyCode + "&pArCustomer=" + pARNum + "&pServiceMasterNum=" + pSMNum;

        //console.log(myCfg.appSettings.webApiServerBaseUrl + 'api/CustomerPortalApp/WidgetsToShow?' + args); 
        
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/CustomerPortalApp/WidgetsToShow?'+args,
            {
                method: 'GET',               
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {           
                if (container.success) {
                    const data: Widget[] = container.data;
                    if (data.length > 0) {

                        dispatch({ type: 'WIDGET_LOAD', newState: { items: data, loaded: true } });
                    }
                } else {                
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });              
                }
            });

    }
}

export const reducer: Reducer<WidgetList> = (state: WidgetList | undefined, incomingAction: Action): WidgetList => {
    

    if (state === undefined) {
        return { ...initialWidgetListState };
    }
    const action = incomingAction as KnownAction;    
    switch (action.type) {
        case 'WIDGET_LOAD':
            var myAction = incomingAction as LoadWidgets;
            return myAction.newState;
        case 'STORE_RESET':
            return { ...initialWidgetListState };
        default:
            return state;
    }
}; 

